
































import { Component, Prop, Vue } from "vue-property-decorator";

import Close from "../../resources/close.vue";
import DoDeleteAccountModal from "./doDeleteAccountModal/doDeleteAccountModal.vue";
import DeleteAccountDoneModal from "./deleteAccountDoneModal/deleteAccountDoneModal.vue";

import { ResourceHelper } from "@/helper/resourceHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { CloudAccount } from "@/cloudAccount/cloudAccount";

@Component({
  components: {
      Close,
      DoDeleteAccountModal,
      DeleteAccountDoneModal
  }
})

export default class DeleteAccount extends Vue {
    @Prop() private cloudAccount! : CloudAccount;

    onetimePass = "";
    isDoDeleteAccountModal = false;
    isDeleteAccountDoneModal = false;
    isCanSubmit = false;

    isError = true;
    errorMessages = new Array();

    private mounted(){
        (this.$refs.onetimePass as HTMLElement).focus();
    }

    private setCanSubmit(){
        this.isCanSubmit = true;
    }

    private keyupEnter(element){
        if(!this.isCanSubmit){ return; }
        this.isCanSubmit = false;
        (this.$refs[element] as HTMLElement).blur();
        if(this.onetimePass == ""){ return; }
        this.isDoDeleteAccountModal = true;
    }

    private get message(){
        return "メールを送信しました。\nメールに記載されているユーザー削除コードを入力してください。"
    }

    private error(message: string[]){
        this.isError = true;
        this.errorMessages = new Array();
        for(var i = 0; i < message.length; i++){
            this.errorMessages.push({index: i, message: message[i]});
        }
    }

    private deleteDone(){
        this.cloudAccount.isSignIn = false;
        this.cloudAccount.signOutType = 1;
        CookieHelper.removeItem("authorizationToken");
        // CookieHelper.removeItem("accessToken");
        // CookieHelper.removeItem("refreshToken");
        // CookieHelper.removeItem("accessLimit");
        // CookieHelper.removeItem("refreshLimit");
        this.isDoDeleteAccountModal = false;
        this.isDeleteAccountDoneModal = true;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBorderColor(){
        var style = {
            border : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background : this.$store.getters.userConfigColors.backgroundColor
        };
        return style;
    }
    private get userConfigBorderBottomColor(){
        var style = {
            borderBottom : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigButtonColor(){
        var style = {
            background : this.userConfigColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
